'use client';

import { createContext } from 'react';

// Holds the server-fetched getNavigationMenus data so ConsumerMobileFooterMenu
// can resolve without a client-side Apollo useSuspenseQuery round-trip.
// Default undefined = no provider in tree (falls through to Apollo).
const NavMenusContext = createContext(undefined);

export default NavMenusContext;
